import { render, staticRenderFns } from "./CnDetail.vue?vue&type=template&id=501902e4&scoped=true&"
import script from "./CnDetail.vue?vue&type=script&lang=js&"
export * from "./CnDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501902e4",
  null
  
)

export default component.exports